var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading",style:(_vm.style)},[_c('img',{attrs:{"src":require("../assets/img/loading_circle.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }